import FilledIcon from '../filled-icon/filled-icon'
import {
  default as Icon,
  Props as IconProps,
  IconSizes,
  Icons,
} from '../icon/icon'
import { FillColorVariables } from '../shared-types'

export type Props = {
  icon: Icons
  size: IconSize
  color?: IconProps['color']
  background?: FillColorVariables
}

type IconSize = 'small' | 'medium' | 'large'

const iconSizes: Record<IconSize, IconSizes> = {
  small: 24,
  medium: 32,
  large: 48,
}

export default function RadioActionIcon({
  icon,
  size,
  background,
  color,
}: Props) {
  if (background != null) {
    return (
      <FilledIcon
        size={size}
        icon={icon}
        background={background}
        marginRight="small"
      />
    )
  }

  return (
    <Icon
      icon={icon}
      size={iconSizes[size]}
      color={color}
      marginRight="small"
    />
  )
}
